// extracted by mini-css-extract-plugin
export default {"actions":"product-table-row_actions__Am2vQ","last-row":"product-table-row_last-row__RlU1z","wrapProductTableRow":"product-table-row_wrapProductTableRow__jtaQT"};